import * as DashboardConstants from '.././DashboardConstants';

export const alertKpiTableHeaders = [
    {
        key: 'engagement',
        header: DashboardConstants.Engage
    },
    {
        key: 'red',
        header: DashboardConstants.Red
    },
    {
        key: 'yellow',
        header: DashboardConstants.Yellow
    },
    // {
    //     key: 'green',
    //     header: DashboardConstants.Green
    // },
    {
        key: 'ticketedAlerts',
        header: DashboardConstants.TicketedAlerts
    },
    {
        key: 'duplicatedAlerts',
        header: DashboardConstants.DuplicateAlerts 
    },
    {
        key: 'nonTicketsAlerts',
        header: DashboardConstants.InformationalAlerts 
    },
    {
        key: 'ticketConversionRate',
        header: DashboardConstants.TicketConversionRate
    },
    {
        key: 'avgAlertAnalysisTime',
        header: DashboardConstants.AvgAlertAnalysisTimeMin
    },
    {
        key: 'avgAlertResolutionTime',
        header: DashboardConstants.AvgAlertResolutionTimeMin
    }
];

export const alertMetricTableHeaders = [
    {
        key: 'alert',
        header: DashboardConstants.Alert
    },
    {
        key: '01',
        header: '2021-01-01'
    },
    {
        key: '02',
        header: '2021-02-01'
    },
    {
        key: '03',
        header: '2021-03-01'
    },
    {
        key: '04',
        header: '2021-04-01'
    },
    {
        key: '05',
        header: '2021-05-01'
    },
    {
        key: '06',
        header: '2021-06-01'
    }
];

export const alertMetricTableData = [
    {
        id: '1',
        alert: 'ABAP Instance not available',
        entity: 'PC0~ABAP~pc0-26_PC0_20',
        '06': 10,
        '05': 10,
        '04': 10,
        '03': 10,
        '02': 10,
        '01': 10
    },
    {
        id: '2',
        alert: 'Long Running Dialogs',
        entity: 'PC0~ABAP~pc0-26_PC0_22',
        '06': 10,
        '05': 10,
        '04': 10,
        '03': 10,
        '02': 10,
        '01': 10
    },
    {
        id: '3',
        alert: 'Long Running Dialogs',
        entity: 'PC0~ABAP~pc0-26_PC0_23',
        '06': 10,
        '05': 10,
        '04': 10,
        '03': 10,
        '02': 10,
        '01': 10
    },
    {
        id: '4',
        alert: 'Long Running Dialogs',
        entity: 'PC0~ABAP~pc0-26_PC0_22',
        '06': 10,
        '05': 10,
        '04': 10,
        '03': 10,
        '02': 10,
        '01': 10
    },
    {
        id: '5',
        alert: 'Errors in ABAP System Log',
        entity: 'PC0~ABAP~pc0-26_PC0_21',
        '06': 10,
        '05': 10,
        '04': 10,
        '03': 10,
        '02': 10,
        '01': 10
    }
]